import { HttpClient } from '@angular/common/http';
import { KeycloakService } from 'keycloak-angular';
import * as myGlobals from 'src/app/globals';
import { EnvironmentSgeUrlService } from 'src/app/services/environmentSgeUrl.service';
import { configEnvironment } from 'src/config/config';

export let keycloakConfig!: any;
export function initializer(httpClient: HttpClient, sgeService: EnvironmentSgeUrlService, keycloak: KeycloakService): () => Promise<any> {
  return (): Promise<any> =>
    new Promise(async (resolve, reject) => {
      try {
        Object.assign(myGlobals.Config, configEnvironment);

        sgeService.sgeCrypto.init('./assets/lib/sge/worker.js', myGlobals.Config.sgeUrl);

        resolve(true);
      } catch (error) {
        reject(error);
      }
    });
}
